export enum appRoutingEnum {
  MAIN = 'main',
  HOME = 'home',
  LOGIN = 'login',
  PROFILE = 'profile',
  DIALOG = 'dialog',
  ADVANCED_SEARCH_RESULT = 'advanced-search-result',
  ADVANCED_SEARCH = 'advanced-search',
  CHANGE_PHOTO = 'change-photo',
  NOTIFICATIONS = 'notifications',
  TERMS = 'terms',
  PASSWORD_RECOVERY = 'password-recovery',
  CONTACT_US = 'contact-us',
  REGISTER = 'register',
  INBOX = 'inbox',
  ARENA = 'arena',
  SEARCH = 'search',
  CHANGE_PASSWORD = 'change-password',
  FREEZE_ACCOUNT = 'freeze-account',
  SETTINGS = 'settings',
  SUBSCRIPTION = 'subscription',
  BINGO = 'bingo',
  ACTIVATION = 'activation',
  FULL_SCREEN_PROFILE = 'full-screen-profile',
  ADMIN_MESSAGES = 'admin-messages',
  PAGE = 'page',
  FAQ = 'faq',
  LOGOUT = 'logout',
  MAGAZINE = 'magazine',
  RELOAD = '',
}
